import { createGenericStore } from '@/stores/utils/genericStore.js' // Assumes genericStore.js is in your main app's 'resources/js/utils/'
import axios from 'axios'

// 1. Define your custom options
const NotesStoreOptions = {
  state: () => ({
    noteableId: null,
    noteableType: null,
  }),

  // Custom getters
  getters: {
    hasActiveNoteableContext(state) {
      return state.noteableId !== null && typeof state.noteableType === 'string' && state.noteableType.length > 0
    },
  },

  // Custom actions
  actions: {
    setNoteableContext(noteableId, noteableType) {
      this.noteableId = Number(noteableId)
      this.noteableType = noteableType
    },

    async fetchItemsForNoteable(noteableId, noteableType, params = {}) {
      this.setNoteableContext(noteableId, noteableType)

      return this.fetchItems({
        clear: true,
        noteable_id: this.noteableId,
        noteable_type: this.noteableType,
        ...params,
      })
    },

    async createForActiveNoteable(payload = {}) {
      if (!this.hasActiveNoteableContext) {
        throw new Error('Cannot create note without an active noteable context.')
      }

      return this.itemCreate({
        noteable_id: this.noteableId,
        noteable_type: this.noteableType,
        ...payload,
      })
    },

    async replyToNote(sourceNoteId, payload = {}) {
      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.post(`${this.api}/${sourceNoteId}/replies`, payload)
        this.itemPatchState(data)

        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },
  }
}

// 2. Create the store hook using your generic factory
export const useNotesStore = createGenericStore(
  'Notes', // Base Store ID
  '/api/v1/notes', // API Endpoint
  NotesStoreOptions // Pass in your custom logic
)
